// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__TJC7Q","column":"Contact_column__1M+5D","avatar":"Contact_avatar__fIPkH"};